import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';

const Newsletter = () => {
    const COMPONENT_SELECTOR = '[data-component="newsletter"]';
    const FORM_SELECTOR = `${COMPONENT_SELECTOR} form`;

    new Bouncer(FORM_SELECTOR, {
        disableSubmit: true,
        messageAfterField: true,
        messages: {
            missingValue: {
                checkbox: '',
                radio: '',
                select: '',
                'select-multiple': '',
                default: 'Campo de preenchimento obrigatório',
            },
            patternMismatch: {
                email: 'Por favor, insira um e-mail válido',
                telefone: 'Por favor, insira um telefone válido',
                default: 'Formato inválido',
            },
        },
        emitEvents: true,
    });

    document.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
        const form = component.querySelector('form');
        if (!form) return;

        form.addEventListener('bouncerFormValid', async (event) => {
            event.preventDefault();

            const submit = form.querySelector('[type="submit"]');
            if (submit) {
                submit.setAttribute('disabled', 'disabled');
            }

            const data = Object.fromEntries(new FormData(form).entries());

            try {
                const response = await axios.post(
                    `${appConfig.baseApiUrl}basedigital/v1/cadastro-newsletter/`,
                    data,
                    { headers: { 'Content-Type': 'application/json' } }
                );

                form.querySelectorAll('label').forEach((el) => {
                    el.classList.add('hidden');
                });

                form.querySelector('.success').classList.remove('hidden');

                // console.log('[Newsletter] sucesso:', response?.data);
            } catch (err) {
                form.querySelectorAll('label').forEach((el) => {
                    el.classList.add('hidden');
                });
                form.querySelector('.success').classList.remove('hidden');
                // console.error('[Newsletter] erro:', err?.response?.data || err?.message);
            }
        });
    });
};

export default Newsletter;

if (document.querySelector('[data-component="newsletter"]')) {
    Newsletter();
}
